// LearningPopup.jsx
// Learning popup shown after an activity is submitted — matches room.php's
// #customStageModal / .modal-text populated from `stageEndTexts`. Visually
// identical shell to StoryPopup (PHP reuses the same modal for both); kept
// as a separate component since the two will diverge in later phases
// (learning popups feed into stage transitions, clue popups don't).
import React from 'react';
import GamePopup from './GamePopup';
import './TextPopup.css';

function LearningPopup({ open, onClose, text, testId = 'escape-learning-popup' }) {
  return (
    <GamePopup open={open} onClose={onClose} size="small" ariaLabel="Learning" testId={testId}>
      <div className="escape-popup-text">{text}</div>
    </GamePopup>
  );
}

export default LearningPopup;
